var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_21188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.30493 4.96321V11.9692C2.30493 18.842 10.5 22.2164 10.8489 22.3541C10.904 22.3771 10.9637 22.3862 11.0187 22.3862C11.0738 22.3862 11.1335 22.3771 11.1886 22.3541C11.5375 22.2118 19.7326 18.8374 19.7326 11.9692V4.96321C19.7326 4.72448 19.5489 4.52706 19.3148 4.50411C19.2735 4.49951 15.2792 4.10927 11.308 0.913904C11.1381 0.780764 10.8994 0.780764 10.7341 0.913904C6.77202 4.10009 2.76404 4.49951 2.72272 4.50411C2.48857 4.52706 2.30493 4.72448 2.30493 4.96321ZM3.22314 5.36263C4.36631 5.18358 7.64891 4.46279 11.0187 1.85507C14.3886 4.46279 17.6712 5.18358 18.8143 5.36263V11.9692C18.8143 17.6988 12.1803 20.9125 11.0187 21.4313C9.85721 20.9125 3.22314 17.7034 3.22314 11.9692V5.36263Z",
    fill: "#214A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63183 14.0122C9.72365 14.104 9.83843 14.1453 9.9578 14.1453C10.0772 14.1453 10.1919 14.0994 10.2838 14.0122L15.5176 8.77838C15.6966 8.59933 15.6966 8.31009 15.5176 8.13104C15.3385 7.95199 15.0493 7.95199 14.8702 8.13104L9.9578 13.0389L7.17103 10.2521C6.99198 10.0731 6.70274 10.0731 6.52369 10.2521C6.34464 10.4312 6.34464 10.7204 6.52369 10.8994L9.63183 14.0122Z",
    fill: "#214A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_21188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.037,
    height: 22.037,
    fill: "white",
    transform: "translate(0 0.583328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.a0c7357b7a01b368fa47aea6ab2ed757.svg";
export { ForwardRef as ReactComponent };